// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__g2Qxc","mainHeader":"Header_mainHeader__t0eCq","imgContainer":"Header_imgContainer__UIsdE"};